import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {getLocationData} from '../../actions/locationData'
import './LocationDetails.scss'
const LocationDetails = () => {

    const dispatch = useDispatch();
    const [text, setText] = useState('');
    const {locationData} = useSelector((state)=>state.locationData)
    //console.log(locationData)
    // console.log(locationData)

    
   const getData =()=>{
     if (text.length>0){
    dispatch(getLocationData(text));
     }
    //console.log(locationData[0].lon)
   }
    

  return (
    <>
    <div className="input-container">
        <div className="searchBar">
          <input type="text" 
        
           placeholder='Insert place'
           onChange={(e)=>setText(e.target.value)}
          />
          <button  onClick={(e)=>getData()}>Get Weather</button>
        </div>
    </div>
    

    </>
  )
}

export default LocationDetails